// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyDBLt6BnlyDHlhLK7HYlFe0LXz8mDUwvTU",
  authDomain: "df-portfolio-c4e64.firebaseapp.com",
  projectId: "df-portfolio-c4e64",
  storageBucket: "df-portfolio-c4e64.appspot.com",
  messagingSenderId: "408680642160",
  appId: "1:408680642160:web:8d3ff4f226d68fe70aa6b5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export {app, auth};